import React from 'react';
import './NotesSkeleton.css';

/**
 * Skeleton loader component for the notes section
 * Shows skeleton cards while notes are loading
 */
const NotesSkeleton = ({ count = 6 }) => {
    return (
        <div className="notes-skeleton-grid">
            {/* Create New Note Card Skeleton */}
            <div className="skeleton-note-card skeleton-create-card">
                <div className="skeleton-create-icon" />
                <div className="skeleton-create-label" />
            </div>

            {/* Note Cards Skeleton */}
            {Array.from({ length: count }).map((_, index) => (
                <div key={index} className="skeleton-note-card">
                    <div className="skeleton-note-content">
                        <div className="skeleton-note-title" />
                        <div className="skeleton-note-excerpt">
                            <div className="skeleton-note-line" />
                            <div className="skeleton-note-line" />
                            <div className="skeleton-note-line skeleton-note-line-short" />
                        </div>
                        <div className="skeleton-note-badges">
                            <div className="skeleton-badge" />
                            <div className="skeleton-badge skeleton-badge-small" />
                        </div>
                    </div>
                    <div className="skeleton-note-footer">
                        <div className="skeleton-note-actions">
                            <div className="skeleton-icon-btn" />
                            <div className="skeleton-icon-btn" />
                            <div className="skeleton-icon-btn" />
                            <div className="skeleton-icon-btn" />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default NotesSkeleton;
